import { Navigation } from 'lucide-react';

import { Badge } from '@/components/badge';
import { Heading } from '@/components/heading';
import { Text } from '@/components/text';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card';
import { SUEZ_CANAL_ID } from '@/lib/constants';
import { RouteViaInterface } from '@/types';

interface OptionViaBadgeProps {
  via: RouteViaInterface[];
  isShort?: boolean;
}

const OptionViaBadge = ({ via, isShort }: OptionViaBadgeProps) => {
  return via.map((location) => {
    const isViaSuez = location.locationId === SUEZ_CANAL_ID;

    return (
      <HoverCard key={location.locationId} openDelay={150}>
        <HoverCardTrigger>
          <Badge variant={isViaSuez ? 'negativeLight' : 'light'} className="font-medium leading-snug">
            <Navigation className="mr-1.5 size-3" /> {isShort ? location.short : location.long}
          </Badge>
        </HoverCardTrigger>
        <HoverCardContent>
          <div>
            <div className="rounded-t-md bg-states-warning-backgroundColor px-4 py-3 leading-snug text-text-primary">
              <Heading variant="h5" className="mb-1">
                Route alert
              </Heading>
              <Text variant="sm" className="mb-0">
                {location.description}
              </Text>
            </div>
          </div>
        </HoverCardContent>
      </HoverCard>
    );
  });
};

export { OptionViaBadge };
